import React from 'react'

export default function AboutText() {
    return (
        <div className="col-sm-12">
            <h2 className="module-title font-alt align-left">Victoria Car Service Center</h2>
            <div className="module-subtitle font-serif align-left mb-20">The future belongs to those who believe in the beauty of their dreams.</div>
            <p>Dream. We can boldly say that if there was no dream, there would be no VICTORIA today. A dream that everything is executed as quickly as possible with the best details. Victoria is a car service center that uses simulation technologies to visualize all your customizations before implementing them.</p>
            <p>We believe that with current technologies, it is possible to observe any change in the car before implementing it and make a better decision. That's why we created VICTORIA. A website where you can first see all the tunings you need in real time and then place an order.</p>
        </div>
    )
}
